module.exports = __webpack_public_path__ + "media/images/iconDelete__okGreen-71f0c2ea33d93b1949fc0176d2b0be6b.png";